import { Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import SubCard from 'ui-component/cards/SubCard'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import SnackBar from '../General/SnackBar';
import BackdropLoader from '../General/Loader';
import { DeleteUser } from 'API/Dev/api';

const DeletePage = () => {
    const [Data, setData] = useState({ delete_by: "", delete_parameter: "", user_type: "" })
    const [Alert, setAlert] = useState({ open: false, message: "", type: "" });
    const [Loading, setLoading] = useState(false);


    const handleAlertOpen = (message, type) => {
        setAlert({
            open: true,
            message: message,
            type: type
        });
    }

    const handleAlertClose = () => {
        setAlert({
            open: false,
            message: "",
            type: ""
        });
    }


    const handleSubmit = () => {

        if (Data.delete_by && Data.delete_parameter && Data.user_type) {
            if (Data.delete_by === "mobile_number" && Data.delete_parameter.length !== 10 && /^[0-9]*$/.test(Data.delete_parameter)) {
                handleAlertOpen("Mobile number should be 10 digits", "error");
                return;
            }
            else if (Data.delete_by === "email_address" && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(Data.delete_parameter)) {
                handleAlertOpen("Invalid email address format", "error");
            }
            else if (Data.delete_by === "pan_number" && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(Data.delete_parameter)) {
                handleAlertOpen("Invalid PAN number format", "error");
            }
            else {
                DeleteUser(Data, handleAlertOpen, setLoading, setData);
            }
            // Here you can add the API call to delete the user
        }

        else {
            handleAlertOpen("Please fill all fields", "error");
        }
    }

    const handleChange = (name, value) => {
        if (name === "delete_parameter") {
            // console.log("name", name,value);
            if (Data.delete_by === "mobile_number" && value.length <= 10 && /^[0-9]*$/.test(value)) {
                console.log("value", value);

                setData((prevData) => ({
                    ...prevData,
                    [name]: value
                }));
            }
            else if (Data.delete_by === "email_address" && /^[a-z0-9@._]*$/.test(value)) {
                setData((prevData) => ({
                    ...prevData,
                    [name]: value
                }));
            }
            else if (Data.delete_by === "pan_number" && /^[a-zA-Z0-9]*$/.test(value)) {
                setData((prevData) => ({
                    ...prevData,
                    [name]: value.toUpperCase()
                }));
            }

        }
        else if (name === "delete_by") {
            setData((prevData) => ({
                ...prevData,
                [name]: value,
                delete_parameter: ""
            }));
        }
        else {
            setData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }

        // console.log("Data", Data);
    }


    return (
        <SubCard title="Delete User" sx={{ height: '80vh' }}>
            <SnackBar open={Alert.open} message={Alert.message} type={Alert.type} handleClose={handleAlertClose} />
            <BackdropLoader open={Loading} />
            <Grid container spacing={2} sx={{ padding: 2 }} justifyContent="space-between">
                <Grid item md={3} xs={12}>
                    <FormControl fullWidth size='small'>
                        <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >User Type</Typography>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={Data.user_type}
                            onChange={(e) => handleChange("user_type", e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                    borderRadius: '8px', // change border radius
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                },
                            }}
                        >
                            <MenuItem value={"agent"}>Agent</MenuItem>
                            <MenuItem value={"distributor"}>Distributor</MenuItem>
                            {/* <MenuItem value={"pan_number"}>Pan Number</MenuItem> */}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md={3} xs={12}>
                    <FormControl fullWidth size='small'>
                        <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >Delete By</Typography>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={Data.delete_by}
                            onChange={(e) => handleChange("delete_by", e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                    borderRadius: '8px', // change border radius
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                },
                            }}
                        >
                            <MenuItem value={"mobile_number"}>Mobile Number</MenuItem>
                            <MenuItem value={"email_address"}>Email Address</MenuItem>
                            <MenuItem value={"pan_number"}>Pan Number</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item md={3} xs={12}>
                    <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >Parameter</Typography>
                    <TextField
                        id="outlined-basic"
                        variant="outlined"
                        disabled={Data.delete_by ? false : true}
                        value={Data.delete_parameter ? Data.delete_parameter : ""}
                        size='small'
                        fullWidth
                        onChange={(e) => handleChange("delete_parameter", e.target.value)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                border: '2px solid #A9A9A980 50%', // change border color
                                borderRadius: '8px',
                            },
                            '& fieldset': {
                                borderColor: '#A9A9A980',
                                borderRadius: '8px',
                                color: "#000"// default border color
                            },
                        }}
                    />

                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ padding: 2 }} justifyContent="center">
                <Grid item md={2} xs={12}>
                    <Button
                        variant='contained'
                        color='secondary'
                        sx={{
                            backgroundColor: "#688B2A",
                            color: "#FFFFFF",
                            borderRadius: "6px",
                            "&:hover": {
                                backgroundColor: "#688B2A",
                            },
                        }} fullWidth onClick={() => handleSubmit()}>
                        Delete User
                    </Button>
                </Grid>
            </Grid>
        </SubCard>
    )
}

export default DeletePage